module.exports = __webpack_public_path__ + "img/videoUpload.228f4a22.png";